module.exports = __webpack_public_path__ + "static/media/portSS.344ad585.jpg";